// Module
var code = `<h2 class="section-header">Please confirm the following:</h2>
<form name="\$ctrl.form">
  <table class="table">
    <tbody>
    <tr>
      <td>Name:</td>
      <td>
        <input type="text"
               required
               minlength="1"
               maxlength="64"
               ng-model="\$ctrl.name"/>
      </td>
    </tr>
    <tr>
      <td>Content:</td>
      <td>
        <file-upload ng-model="\$ctrl.contentFile"
                     required
                     validate-uploaded
                     max-files="1"
                     show-file-name="false"
                     show-remarks="false"
                     enable-webcam="false">
        </file-upload>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="flex-end">
    <button
        type="submit"
        class="btn btn-success"
        ng-disabled="\$ctrl.form.\$invalid"
        ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/upload-chart-of-accounts/upload-chart-of-accounts.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;